import React, { FC, useEffect } from 'react';
import { Spinner } from '../Spinner';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useParams } from 'react-router-dom';
import { ApplicationDetailsHeader } from './ApplicationDetailsHeader';
import { PageTitle } from '../../layout/core';
import { breadcrumbs } from './NewApplication';
import { useTranslation } from 'react-i18next';
import {
  fetchRegularApplicationData,
  setToDefaultApplicationData,
} from '../../store/merchnts/actions/application';
import { ApplicationDetailsLayout } from './ApplicationDetailsLayout';

interface Props {
  children: React.ReactElement;
}
export const ApplicationDetails: FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const { applicationId } = useParams<{ applicationId: string }>();

  const { merchantState, dispatch } = useMerchants();
  const { isApplicationDataLoading } = merchantState;

  useEffect(() => {
    void fetchRegularApplicationData({ dispatch, applicationId });
  }, []);

  useEffect(() => {
    return () => {
      setToDefaultApplicationData(dispatch);
    };
  }, []);

  if (isApplicationDataLoading) {
    return (
      <div className="card h-100">
        <div className="card-body">
          <Spinner pageLoader/>
        </div>
      </div>
    );
  }
  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs(t)}>
        {applicationId}
      </PageTitle>

      <ApplicationDetailsHeader />

      <ApplicationDetailsLayout />

      {children}
    </>
  );
};